module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Black-Beauty.e020fd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Black-Beauty.jpg
// module id = G+H4
// module chunks = 0